import { fetchApi } from '@/app/api';
import {
  CreateFeedbackPayload,
  DTO,
  Feedback,
  parseFeedbackDto,
} from '@certhon/models';
import { first } from '@/lib/api-utils';

/** Fetch all feedback for a proto list (template). */
export async function fetchFeedbackForList(
  protoListId: string,
): Promise<Feedback[]> {
  const dtos = await fetchApi('/feedback', {
    proto_list_id: `eq.${protoListId}`,
    deleted: 'eq.false',
    order: 'timestamp.desc',
  });
  return dtos.map(parseFeedbackDto);
}

/** Fetch all feedback submitted by a specific user. */
export async function fetchFeedbackForUser(
  userId: number,
): Promise<Feedback[]> {
  const dtos = await fetchApi('/feedback', {
    user_id: `eq.${userId}`,
    deleted: 'eq.false',
    order: 'timestamp.desc',
  });
  return dtos.map(parseFeedbackDto);
}

/** Submit new feedback on a checklist question. */
export async function createFeedback(
  payload: CreateFeedbackPayload,
): Promise<Feedback> {
  const dtos = (await fetchApi('/feedback', undefined, {
    method: 'POST',
    body: JSON.stringify(payload),
  })) as unknown as DTO<Feedback>[];
  return parseFeedbackDto(first(dtos));
}

/** Mark feedback as handled by a specific user. */
export async function markFeedbackHandled(
  id: string,
  handledUserId: number,
): Promise<Feedback> {
  const dtos = (await fetchApi(
    '/feedback',
    { id: `eq.${id}` },
    {
      method: 'PATCH',
      body: JSON.stringify({
        handled: true,
        handled_user_id: handledUserId,
      }),
    },
  )) as unknown as DTO<Feedback>[];
  return parseFeedbackDto(first(dtos));
}
